module.exports = __webpack_public_path__ + "img/error-page-icon.b9c22486.svg";